import { Typography } from "@mui/material";
import { PhaseListForms } from "./types";
import React from "react";

const LockStatus = ({
  selectedForm,
}: {
  selectedForm: PhaseListForms | null;
}) => {
  if (!selectedForm?.isSigned && !selectedForm?.locked) return null;

  const isSame =
    selectedForm?.lockedAt === selectedForm?.signedAt &&
    selectedForm?.signedBy === selectedForm?.lockedBy;

  return (
    <>
      {isSame ? (
        <Typography variant="body1" color="text.secondary">
          This Form was signed and locked by{" "}
          <strong>{selectedForm?.signedBy}</strong> at {selectedForm?.signedAt}
        </Typography>
      ) : (
        <>
          {selectedForm?.isSigned && (
            <Typography variant="body1" color="text.secondary">
              This Form was signed by <strong>{selectedForm?.signedBy}</strong>{" "}
              at {selectedForm?.signedAt}
            </Typography>
          )}
          {selectedForm?.locked && (
            <Typography variant="body1" color="text.secondary">
              This Form was locked by <strong>{selectedForm?.lockedBy}</strong>{" "}
              at {selectedForm?.lockedAt}
            </Typography>
          )}
        </>
      )}
    </>
  );
};

export default React.memo(LockStatus);
